var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var cwRoutePrefix = {
    instructor: '/courseware/instructor',
    student: '/courseware/student'
};
export var PerformancePath = {
    oldHomepage: '/report-menu',
    newHomePage: "".concat(cwRoutePrefix.instructor, "/new"),
    engagement: {
        home: "".concat(cwRoutePrefix.instructor, "/engagement"),
        student: "".concat(cwRoutePrefix.instructor, "/engagement/student"),
        assignment: "".concat(cwRoutePrefix.instructor, "/engagement/assignment")
    },
    engagementSummary: "".concat(cwRoutePrefix.instructor, "/engagementSummary"),
    assignmentDetail: "".concat(cwRoutePrefix.instructor, "/assignmentDetail/:assignmentId"),
    assignmentEngagement: {
        home: "".concat(cwRoutePrefix.instructor, "/assignmentEngagement"),
        byAssignment: "".concat(cwRoutePrefix.instructor, "/assignmentEngagement/byAssignment"),
        byStudent: "".concat(cwRoutePrefix.instructor, "/assignmentEngagement/byStudent/:studentId")
    },
    assignmentSummary: "".concat(cwRoutePrefix.instructor, "/assignmentSummary"),
    assessmentSummary: "".concat(cwRoutePrefix.instructor, "/assessmentSummary"),
    studentEngagement: {
        home: "".concat(cwRoutePrefix.instructor, "/studentEngagement"),
        summary: "".concat(cwRoutePrefix.instructor, "/studentEngagement/summary"),
        gradebook: "".concat(cwRoutePrefix.instructor, "/studentEngagement/gradebook"),
        studentDetail: "".concat(cwRoutePrefix.instructor, "/studentEngagement/studentDetail/:studentId")
    },
    gradeBook: {
        home: "".concat(cwRoutePrefix.instructor, "/gradeBook/home"),
        studentDetail: "".concat(cwRoutePrefix.instructor, "/gradeBook/studentDetail/:studentId")
    },
    disengagedStudent: {
        home: "".concat(cwRoutePrefix.instructor, "/disengagedStudent"),
        studentDetail: "".concat(cwRoutePrefix.instructor, "/disengagedStudent/studentDetail/:studentId")
    },
    studentDetail: "".concat(cwRoutePrefix.instructor, "/studentDetail/:studentId"),
    assessmentDetail: "".concat(cwRoutePrefix.instructor, "/assessmentSummary/exam-detail/:examId"),
    assessmentStudentDetail: "".concat(cwRoutePrefix.instructor, "/assessmentSummary/student-detail/:evolveUserName"),
    hesiReadinessReport: {
        home: '/eaqHesiReadiness'
    },
    courseAggregate: '/courseAggregate',
    eaqTopicReport: {
        home: "".concat(cwRoutePrefix.instructor, "/eaqTopicReport"),
        topicPerformance: "".concat(cwRoutePrefix.instructor, "/eaqTopicReport/byTopic"),
        studentPerformance: "".concat(cwRoutePrefix.instructor, "/eaqTopicReport/byStudent"),
        studentDetail: "".concat(cwRoutePrefix.instructor, "/eaqTopicReport/studentDetail/:studentId")
    }
};
export var DEFAULT_ASSIGNMENT_COMPLETED_CHART_CONFIG = {
    completed: {
        label: 'completed',
        color: 'secondary',
        value: 0
    },
    inProgress: {
        label: 'in progress',
        color: 'secondary-dark',
        value: 0
    },
    pastDue: {
        label: 'past due',
        color: 'custom-old-brick',
        value: 0
    },
    notStarted: {
        label: 'not started',
        color: 'n3',
        value: 0
    }
};
export var CW_INSTRUCTOR_HOME_CARD_TAB_ID = {
    viewStudentEngagement: 'CW_INSTRUCTOR_HOME_TAB_VIEW_STUDENT_ENGAGEMENT',
    viewGradebook: 'CW_INSTRUCTOR_HOME_TAB_VIEW_GRADEBOOK',
    viewAssignment: 'CW_INSTRUCTOR_HOME_TAB_VIEW_ASSIGNMENT',
    veiwDisangagedStudents: 'CW_INSTRUCTOR_HOME_TAB_VIEW_DISENGAGED_STUDENTS'
};
export var DEFAULT_ASSIGNMENT_COMPLETED_CHART_DATA = {
    completed: 0,
    inProgress: 0,
    pastDue: 0,
    notStarted: 0
};
export var ASSIGNMENT_DUE_MENU_LAST_7_DAYS = {
    key: 'last_7_days',
    name: 'in the last 7 days',
    value: 7
};
export var ASSIGNMENT_DUE_MENU_NEXT_7_DAYS = {
    key: 'next_7_days',
    name: 'in the next 7 days',
    value: 7
};
export var ASSIGNMENT_DUE_MENU_NEXT_14_DAYS = {
    key: 'next_14_days',
    name: 'in the next 14 days',
    value: 14
};
export var ASSIGNMENT_DUE_MENU_LAST_30_DAYS = {
    key: 'last_30_days',
    name: 'in the last 30 days',
    value: 30
};
export var ASSIGNMENT_DUE_MENU_SEMESTER = {
    key: 'this_semester',
    name: 'this semester',
    value: 0
};
export var ASSIGNMENT_GRADE_TYPES = {
    PASS_FAIL: {
        key: 'PASS_FAIL',
        label: 'Pass/Fail'
    },
    NOT_GRADED: {
        key: 'NOT_GRADED',
        label: 'Not Graded'
    },
    SCORED: {
        key: 'SCORED',
        label: 'Scored'
    }
};
export var ASSIGNMENT_STATUS = {
    NOT_STARTED: {
        key: 'NOT_STARTED',
        label: 'Not Started'
    },
    IN_PROGRESS: {
        key: 'IN_PROGRESS',
        label: 'In Progress'
    },
    COMPLETED: {
        key: 'COMPLETED',
        label: 'Completed'
    }
};
export var ASSIGNMENT_DUE_MENU_OPTIONS = [ASSIGNMENT_DUE_MENU_SEMESTER, ASSIGNMENT_DUE_MENU_LAST_30_DAYS, ASSIGNMENT_DUE_MENU_LAST_7_DAYS, ASSIGNMENT_DUE_MENU_NEXT_7_DAYS];
export var ASSIGNMENT_DUE_NEW_MENU_OPTIONS = [
    __assign(__assign({}, ASSIGNMENT_DUE_MENU_SEMESTER), { name: 'all' }),
    __assign(__assign({}, ASSIGNMENT_DUE_MENU_NEXT_7_DAYS), { name: 'next week (Next 7 days)' }),
    ASSIGNMENT_DUE_MENU_NEXT_14_DAYS,
    __assign(__assign({}, ASSIGNMENT_DUE_MENU_LAST_7_DAYS), { name: 'last week (Last 7 days)' })
];
export var ASSIGNMENT_PERFORMANCE_SCORE_EIGHTY_FIVE = 85;
export var DISPLAY_PASS_FAIL = {
    PASS: 'Pass',
    FAIL: 'Fail'
};
export var CW_TABLE_SELECTOR = {
    assignmentEngagement: '.c-cw-assignment-engagement',
    assignmentSummaryDetail: '.c-cw-assignment-summary-detail',
    studentAssignmentSummary: '.c-cw-student-detail-assignment-summary-tab',
    studentEngagement: '.c-cw-student-engagement',
    engagementSummary: '.c-cw-engagement-summary-sort'
};
export var TOGGLE_TITLE_GRADED_ASSIGNMENTS_ONLY = 'Graded Assignments Only';
export var CW_ASSIGNMENT_TABLE_NAME = {
    STUDENT_HOME_ASSIGNMENT_SUMMARY: 'STUDENT_HOME_ASSIGNMENT_SUMMARY',
    STUDENT_HOME_ASSIGNMENT_ENGAGEMENT: 'STUDENT_HOME_ASSIGNMENT_ENGAGEMENT',
    STUDENT_DETAIL_ASSIGNMENT_SUMMARY: 'STUDENT_DETAIL_ASSIGNMENT_SUMMARY',
    STUDENT_DETAIL_ASSIGNMENT_ENGAGEMENT: 'STUDENT_DETAIL_ASSIGNMENT_ENGAGEMENT',
    ASSIGNMENT_SUMMARY: 'ASSIGNMENT_SUMMARY'
};
export var EAQ_TOPIC_REPORT = 'EAQ Topic Performance';
export var COURSE_TYPE = {
    EAQ: {
        value: 'EAQ',
        display: 'EAQ',
        displayIcon: 'icon__eaq'
    },
    MASTERY: {
        value: 'MASTERY',
        display: 'EAQ - Mastery',
        displayIcon: 'icon__eaq'
    },
    STANDARD: {
        value: 'STANDARD',
        display: 'EAQ - Standard',
        displayIcon: 'icon__eaq'
    },
    QUIZ_BY_QUESTION: {
        value: 'QUIZ_BY_QUESTION',
        display: 'EAQ - Quiz By Question',
        displayIcon: 'icon__eaq'
    },
    LESSON: {
        value: 'lesson',
        display: 'Lesson',
        displayIcon: 'els-hmds-icon-lesson'
    },
    STUDY_LESSON: {
        value: 'study-lesson',
        display: 'Study Lesson',
        displayIcon: 'els-hmds-icon-lesson'
    },
    CASE_STUDY: {
        value: 'case-study',
        display: 'Case Study',
        displayIcon: 'els-hmds-icon-case-study'
    },
    EBOOK: {
        value: 'ebook',
        display: 'EBook',
        displayIcon: 'els-hmds-icon-ebook-reading'
    },
    POWERPOINT: {
        value: 'powerpoint',
        display: 'Powerpoint',
        displayIcon: 'els-hmds-icon-ppt'
    },
    SIMULATION: {
        value: 'simulation',
        display: 'Simulation',
        displayIcon: 'els-hmds-icon-simulation-nursing'
    },
    SKILL: {
        value: 'skill',
        display: 'Skill',
        displayIcon: 'els-hmds-icon-skills-checklist'
    },
    AFFECTIVE_COMPETENCY: {
        value: 'affective competency',
        display: 'Affective Competency',
        displayIcon: 'els-hmds-icon-coffee'
    },
    NAQ: {
        value: 'naq',
        display: 'NAQ',
        displayIcon: 'els-hmds-icon-exam'
    },
    ACTIVITY: {
        value: 'activity',
        display: 'Activity',
        displayIcon: 'els-hmds-icon-activity'
    },
    GROUP_ACTIVITY: {
        value: 'group-activity',
        display: 'Group Activity',
        displayIcon: 'els-gizmo-icon-group-of-people'
    },
    CHART: {
        value: 'CHART',
        display: 'SimChart',
        displayIcon: 'els-hmds-icon-simulation-nursing'
    },
    AUTHESS: {
        value: 'AUTHESS',
        display: 'EAQ Case Study',
        displayIcon: 'els-gizmo-icon-strawberry'
    }
};
export var EAQ_TOPIC_REPORT_BTN_TEXT = 'Add Adaptive Quiz (EAQ)';
export var EAQ_TOPIC_REPORT_BTN_TEXT_STUDENT_FACING = 'Start a self-study quiz (EAQ)';
export var SUBMISSION_DATE_FORMAT = 'MMM. D, YYYY h:mma';
export var GROUP_TARGET_TYPE = 'GROUP';
export var ASSIGNMENT_NOT_FOUND = 'No assignments found in this range';
export var ASSIGNMENTS_FILTER_RANGE_OPTIONS = [
    {
        key: 'THIS_WEEK',
        name: 'This Week (Next 7 Days)'
    },
    {
        key: 'NEXT_14_DAYS',
        name: 'in the Next 14 Days'
    },
    {
        key: 'LAST_WEEK',
        name: 'Last Week (Past 7 Days)'
    }
];
export var CW_PRODUCT_NAME = 'cw';
export var CW_UPDATED_TAB_NAMES = {
    SUMMARY: 'Summary',
    STUDENT_GRADEBOOK: 'Student Gradebook',
    ENGAGEMENT: 'Engagement',
    ASSESSMENT_SUMMARY: 'Assessment Summary',
    EAQ: 'EAQ',
    ASSIGNMENTS: 'Assignments',
    HESI_SPECIALTY_EXAM_READINESS: 'HESI Specialty Exam Readiness'
};
